import fetchCurrency from '@lyra/core/api/fetchCurrency'
import { PublicGetCurrencyResultSchema } from '@lyra/core/api/types/public.get_currency'
import filterNulls from '@lyra/core/utils/filterNulls'
import useSWR from 'swr'

import { CollateralId } from '../constants/tokens'
import { getActiveCollateral } from '../utils/tokens'

const fetcher = async () => {
  const currencyData = filterNulls(
    await Promise.all(
      getActiveCollateral().map(async (currency) => {
        try {
          return {
            collateralId: currency,
            data: (await fetchCurrency({ currency })).result,
          }
        } catch (error) {
          return null
        }
      })
    )
  )
  return currencyData.reduce(
    (dict, obj) => ({
      ...dict,
      [obj.collateralId]: obj.data,
    }),
    {} as Partial<Record<CollateralId, PublicGetCurrencyResultSchema>>
  )
}

export default function useAllCollateralData() {
  return useSWR(['AllCollateralData'], fetcher, { revalidateOnFocus: false })
}
